import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { RequestStatus, useLoadDot } from "common-frontend-components";
import CircularProgress from '@mui/material/CircularProgress';
import Typography from "@mui/material/Typography";
import { textColor } from "../../assets/styles/colors";
import { Grid } from "@mui/material";
export const LoadingPleaseWait = () => {
    const dots = useLoadDot(true);
    return (_jsxs(Grid, { container: true, justifyContent: 'center', sx: { paddingTop: '64px' }, children: [_jsx(CircularProgress, { sx: { color: textColor, marginBottom: 1 } }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsxs(Typography, { sx: { fontSize: '1rem', padding: 1, color: textColor, textAlign: 'center' }, color: "text.secondary", gutterBottom: true, children: ["Please wait", _jsx("span", { style: { position: 'relative' }, children: _jsx("span", { style: { position: 'absolute' }, children: dots }, void 0) }, void 0)] }, void 0) }, void 0)] }, void 0));
};
const isLoading = (status, data) => status !== undefined && status === RequestStatus.loading && (data === undefined || data.length === 0);
export const UseLoader = ({ useLoad, children, }) => {
    const { data, status } = useLoad();
    if (isLoading(status, data))
        return _jsx(LoadingPleaseWait, {}, void 0);
    return _jsx(_Fragment, { children: children }, void 0);
};
export const UseLoaders = ({ useLoads, onLoaded: OnLoaded, onLoading: OnLoading = LoadingPleaseWait, onError: OnError = () => _jsx(_Fragment, {}, void 0), }) => {
    const res = [];
    for (const useLoad of useLoads)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        res.push(useLoad());
    for (const i of res) {
        if (isLoading(i.status, i.data))
            return _jsx(OnLoading, {}, void 0);
        if (i.status === RequestStatus.failed)
            return _jsx(OnError, {}, void 0);
    }
    return _jsx(OnLoaded, {}, void 0);
};
export const Loader = ({ status, children, data, statuses, }) => {
    if (statuses !== undefined)
        for (const i of statuses)
            if (isLoading(i, data))
                return _jsx(LoadingPleaseWait, {}, void 0);
    if (isLoading(status, data))
        return _jsx(LoadingPleaseWait, {}, void 0);
    return _jsx(_Fragment, { children: children }, void 0);
};
//# sourceMappingURL=Loader.js.map